import Backbone from 'backbone'
import OriginalMarionette from 'backbone.marionette'
import MarionetteHelper from 'happi-helpers/marionette'
import 'backbone.stickit'

MarionetteHelper(OriginalMarionette)

function enableStickit(view) {
	view.on('render', function() {
		if (view.model && view.bindings)
			view.stickit()
	})
}

const StickitView = OriginalMarionette.View.extend({
	constructor() {
		OriginalMarionette.View.prototype.constructor.apply(this, arguments)
		enableStickit(this)
	},
})

const StickitCollectionView = OriginalMarionette.CollectionView.extend({
	constructor() {
		OriginalMarionette.CollectionView.prototype.constructor.apply(this, arguments)
		enableStickit(this)
	},
})

export default {
	...OriginalMarionette,
	View: StickitView,
	CollectionView: StickitCollectionView,
	Model: Backbone.Model,
	Collection: Backbone.Collection,
	Router: Backbone.Router,
}

export const Router = Backbone.Router
